module.exports = __webpack_public_path__ + "files/c2f16a7697c008e18b3ed60ff7175700.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Arvo-regular.svg
 ** module id = 842
 ** module chunks = 0
 **/